import { useQuery } from '@tanstack/react-query';
import type { WindowCombinationDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface CatalogueCombinationApiResponse {
  success: boolean;
  data: WindowCombinationDto;
}

/**
 * Hook to fetch a fully resolved combination by its ID.
 * Calls GET /catalogue/combinations/:id
 */
export function useResolvedCombination(combinationId?: number) {
  return useQuery({
    queryKey: queryKeys.catalogue.resolvedCombination(combinationId!),
    queryFn: async () => {
      const response = await apiClient.get<CatalogueCombinationApiResponse>(
        `/catalogue/combinations/${combinationId}`
      );
      return response.data.data;
    },
    enabled: !!combinationId,
    staleTime: 5 * 60 * 1000,
  });
}
